<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>智能人事</Breadcrumb-item>
        <Breadcrumb-item>员工关系</Breadcrumb-item>
        <Breadcrumb-item>转正管理</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <Alert type="warning" show-icon class="tip">
      数据从钉钉同步到本后台；在本后台新增或修改不会写回钉钉。
    </Alert>
    
    <div class="search">
      <Form inline :label-width="60" :show-message="false">
        <Form-item label="状态">
          <Select v-model="query.status" style="width:140px;" clearable @on-change="search">
            <Option value="OPEN">待转正</Option>
            <Option value="DONE">已办</Option>
            <Option value="CANCEL">已取消</Option>
          </Select>
        </Form-item>
        <Form-item label="关键字">
          <Input v-model="query.keyword" placeholder="姓名/钉钉ID" style="width:180px;" @on-enter="search"/>
        </Form-item>
        <Form-item>
          <Button type="primary" @click="search">查询</Button>
        </Form-item>
      </Form>
    </div>
    <div class="btn-wrap">
      <Button type="primary" :loading="syncing" @click="doSync">从钉钉同步</Button>
      <Button style="margin-left:8px;" type="success" @click="openSubmit">新建转正（仅本地）</Button>
    </div>
    <Table :columns="columns" :data="rows" :loading="loading" stripe no-data-text="暂无待转正"></Table>
    <div style="margin-top:12px;text-align:right;">
      <Page :total="total" :current="query.pageIndex" :page-size="query.pageSize"
            show-total @on-change="p => { query.pageIndex=p; load() }"/>
    </div>
    <Modal v-model="showSubmit" title="新建转正（仅本地）" @on-ok="submit">
      <Form :label-width="90">
        <Form-item label="员工姓名"><Input v-model="form.empName"/></Form-item>
        <Form-item label="钉钉userId"><Input v-model="form.dingUserId"/></Form-item>
        <Form-item label="说明"><Input v-model="form.reason" type="textarea"/></Form-item>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { regularizationStatusText, sourceText } from './enumLabels'
export default {
  name: 'SmartHrRegularization',
  data () {
    return {
      loading: false, syncing: false, showSubmit: false,
      rows: [], total: 0,
      query: { pageIndex: 1, pageSize: 20, status: 'OPEN', keyword: '', processType: 'REGULAR' },
      form: { empName: '', dingUserId: '', reason: '' },
      columns: [
        { title: 'ID', key: 'id', width: 80 },
        { title: '员工', key: 'empName', minWidth: 120 },
        { title: '钉钉userId', key: 'dingUserId', minWidth: 140 },
        { title: '状态', key: 'status', width: 100,
          render: (h, { row }) => h('span', regularizationStatusText(row.status)) },
        { title: '说明', key: 'reason', minWidth: 160 },
        { title: '来源', key: 'source', width: 90,
          render: (h, { row }) => h('span', sourceText(row.source)) },
        { title: '操作', width: 120,
          render: (h, { row }) => {
            if (row.status !== 'OPEN') return h('span', '-')
            return h('a', { on: { click: () => this.markDone(row) } }, '办结（本地）')
          }
        }
      ]
    }
  },
  created () { this.load() },
  methods: {
    stripReadonlyTimes (obj) {
      if (!obj || typeof obj !== 'object') return obj
      const payload = Object.assign({}, obj)
      delete payload.gmtCreate
      delete payload.gmtModified
      delete payload.syncedAt
      return payload
    },
    search () { this.query.pageIndex = 1; this.load() },
    load () {
      this.loading = true
      this.$http.post('/smartHr/process/page', this.query).then(res => {
        if (res && res.status === 'ok' && res.data) {
          this.rows = res.data.data || []
          this.total = res.data.totalCount || 0
        }
      }).finally(() => { this.loading = false })
    },
    doSync () {
      this.syncing = true
      this.$http.post('/smartHr/sync', { scope: 'regularization', mode: 'full' }).then(() => {
        this.$Message.success('已触发同步')
        this.load()
      }).finally(() => { this.syncing = false })
    },
    openSubmit () {
      this.form = { empName: '', dingUserId: '', reason: '' }
      this.showSubmit = true
    },
    submit () {
      this.$http.post('/smartHr/process/submit', this.stripReadonlyTimes(Object.assign({ processType: 'REGULAR', status: 'OPEN' }, this.form))).then(res => {
        if (res && res.status === 'ok') {
          this.$Message.success('已创建（仅本地）')
          this.showSubmit = false
          this.load()
        }
      })
    },
    markDone (row) {
      this.$Modal.confirm({
        title: '确认办结？',
        content: '仅更新本后台，不会写回钉钉。',
        onOk: () => {
          this.$http.post('/smartHr/process/update', { id: row.id, status: 'DONE' }).then(res => {
            if (res && res.status === 'ok') {
              this.$Message.success('已办结')
              this.load()
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.tip { margin-bottom: 12px; }
.btn-wrap {
  margin: 8px 0 12px;
  clear: both;
}
</style>



// WEBPACK FOOTER //
// SmartHrRegularization.vue?aa6d7260